<template>
  <div :class="['spinner']" v-if="blades">
    <div
      v-for="blade in blades"
      :key="blade.id"
      class="blade"
      :style="blade.style"
    ></div>
  </div>
</template>
<script setup lang="ts">
const props = withDefaults(defineProps<{ size?: number; color?: string }>(), {
  size: 20,
  color: 'var(--color-text)'
})
const ty = props.size / 3
let angle = 45
let delay = 1.625
const blades = new Array(8).fill(0).map((_, index) => ({
  id: index + 1,
  style: {
    transform: `rotate(${(angle += 45)}deg) translateY(${ty}px)`,
    'animation-delay': `-${(delay -= 0.125)}s`
  }
}))
</script>
<style scoped>
.spinner {
  position: relative;
  width: calc(v-bind(size) * 1px);
  height: calc(v-bind(size) * 1px);
}
.spinner .blade {
  position: absolute;
  top: calc(v-bind(size) / 3 * 1px);
  left: calc(v-bind(size) / 3 * 1px);
  width: calc(v-bind(size) / 10 * 1px);
  height: calc(v-bind(size) / 4 * 1px);
  background-color: v-bind(color);
  border-radius: 1.25px;
  animation: spinner-animation 1s linear infinite;
  will-change: opacity;
}

@keyframes spinner-animation {
  0% {
    opacity: 0.85;
  }
  50% {
    opacity: 0.25;
  }
  100% {
    opacity: 0.25;
  }
}
</style>
